import BaseComponent from '@components/base-component';
import tag from '@components/utility-components';
import * as styles from './picker.module.scss';
import Circle from './picker-circle/picker-circle';
import PickerControls from './picker-controls/picker-controls';
export default class Picker extends BaseComponent {
    machine;
    optionTitle;
    constructor(machine, linkHandler, showMessage) {
        super({ elementTag: 'div', classes: [styles.pickerBlock] });
        this.machine = machine;
        const controls = new PickerControls(this.machine, linkHandler, showMessage);
        const circle = new Circle(this.machine, this.showTitle.bind(this));
        this.optionTitle = tag.div({ classes: [styles.title], text: 'Spin the Wheel !!!' });
        this.appendChildren(controls, this.optionTitle, circle);
        this.machine.on(this.machine.events.machineStateChanged, this.handleStateChanged.bind(this));
    }
    showTitle(title) {
        this.optionTitle.setText(title);
    }
    handleStateChanged(payload) {
        const { trigger } = payload;
        if (trigger === 'navigatePicker') {
            this.optionTitle.setText('Spin the Wheel !!!');
        }
        if (trigger === 'endPick') {
            this.optionTitle.getElement().classList.add(styles.picked);
        }
        if (trigger === 'pick' || trigger === 'navigateOptionsList' || trigger === 'navigateError') {
            this.optionTitle.getElement().classList.remove(styles.picked);
        }
    }
}
